import {Component, Input} from '@angular/core';

@Component({
  selector: 'cm-card-filters',
  template: `
    <div class="cm-card-filters" [hidden]="!_showFilters">
      <div class="cm-card-filters-content">
        <ng-content></ng-content>
      </div>
      <!--<div class="cm-card-filters-close">-->
        <!--<button mat-icon-button color="primary" (click)="_showFilters = false">-->
          <!--<i class="fas fa-times" aria-hidden="true"></i>-->
        <!--</button>-->
      <!--</div>-->
    </div>
  `,
  host: {
  },
})
export class CmCardFiltersComponent {
  _showFilters: boolean;

  @Input()
  set showFilters(showFilters: boolean) {
    this._showFilters = showFilters;
  }

  toggle() {
    this._showFilters = !this._showFilters;
  }
}
